import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * TutorAITabs - Tab component for AI tutor interfaces with gradient active state
 * Supports connected tab groups with different border radius for left/center/right positions
 */
const TutorAITabs = ({ tabs, activeTab, onTabChange }) => {
  const getTabPosition = (index, totalTabs) => {
    if (totalTabs === 1) return 'single';
    if (index === 0) return 'left';
    if (index === totalTabs - 1) return 'right';
    return 'center';
  };

  const handleTabClick = (tabId) => {
    if (tabId !== activeTab && onTabChange) {
      onTabChange(tabId);
    }
  };

  return (
    <div className="tutor-ai-tabs">
      {tabs.map((tab, index) => {
        const position = getTabPosition(index, tabs.length);
        const isActive = tab.id === activeTab;

        return (
          <button
            key={tab.id}
            className={clsx('tutor-ai-tabs__tab', {
              [`tutor-ai-tabs__tab--${position}`]: position,
              'tutor-ai-tabs__tab--active': isActive,
            })}
            onClick={() => handleTabClick(tab.id)}
            type="button"
            aria-selected={isActive}
            role="tab"
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

TutorAITabs.propTypes = {
  /** Array of tab objects with id and label */
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  /** Currently active tab id */
  activeTab: PropTypes.string,
  /** Callback when tab changes */
  onTabChange: PropTypes.func,
};

TutorAITabs.defaultProps = {
  activeTab: null,
  onTabChange: null,
};

export default TutorAITabs;
